/** Anything outside printable ASCII — almost always a Thai keyboard layout left switched on. */
export const NON_ASCII = /[^\x20-\x7E]/;

/**
 * Checks a new password + its confirmation against the API's rules (usecase.validatePassword).
 * `message` is what to show now (nothing while the boxes are still empty); `ok` gates submit.
 */
export function checkNewPassword(password: string, confirm: string): { ok: boolean; message: string | null } {
  let problem: string | null = null;
  if (password.length < 8) problem = 'รหัสผ่านต้องยาวอย่างน้อย 8 ตัวอักษร';
  else if (NON_ASCII.test(password)) problem = 'ใช้ได้เฉพาะตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์ — เปลี่ยนภาษาคีย์บอร์ดเป็น EN';
  const mismatch = confirm !== password;
  const message = password === '' ? null : (problem ?? (mismatch && confirm !== '' ? 'รหัสผ่านทั้งสองช่องไม่ตรงกัน' : null));
  return { ok: problem === null && !mismatch, message };
}
